import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { YearField } from 'components/forms/filters/Year';
import { YEAR_RANGE_NAME } from 'components/searchAds/constants';

import SelectRangeItem from '../SelectRangeItem';

const MIN_NAME = `${YEAR_RANGE_NAME}.min`;
const MAX_NAME = `${YEAR_RANGE_NAME}.max`;

export default class YearItem extends PureComponent {
  static propTypes = {
    onChanged: PropTypes.func.isRequired,
  };

  render() {
    const { onChanged } = this.props;

    return (
      <SelectRangeItem
        minName={MIN_NAME}
        maxName={MAX_NAME}
        onChanged={onChanged}
        renderField={(props) => (
          <YearField {...props} qaSelector="filter-year" />
        )}
      />
    );
  }
}
